<template>
  <div class="container row">
    <vuestic-pre-loader v-show="isLoading" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
    <div class="widget-header col-md-12">Call Tree</div>
    <div class="col-md-12" v-show="!isLoading">
      <vuestic-tree-root>
        <vuestic-tree-category :isOpen="true" :data="dummy" :label="['FoneNumbers']">
          <vuestic-tree-category :isOpen="false" v-for="fonenumber in fonenumbers" :data="fonenumber" :label="fonenumber.name" :key="fonenumber.name[0]">
            <div slot="icon" class="icon">
              <span aria-hidden="true" class="ion ion-md-call"/>
            </div>
            <tree :data="fonenumber">
            </tree>
          </vuestic-tree-category>
        </vuestic-tree-category>
      </vuestic-tree-root>
    </div>
    <div class="col-md-12" v-show="!isLoading">
      <vuestic-tree-root>
        <vuestic-tree-category :isOpen="true" :data="dummy" :label="['SpeedDials']">
          <vuestic-tree-category :isOpen="false" v-for="speedDial in speedDials" :data="speedDial" :label="speedDial.name" :key="speedDial.name[0]">
            <div slot="icon" class="icon">
              <span aria-hidden="true" class="glyphicon glyphicon-phone"/>
            </div>
            <tree :data="speedDial">
            </tree>
          </vuestic-tree-category>
        </vuestic-tree-category>
      </vuestic-tree-root>
    </div>
    <div class="col-md-12" v-show="!isLoading">
      <vuestic-tree-root>
        <vuestic-tree-category :isOpen="true" :data="dummy" :label="['Devices']">
          <vuestic-tree-category :isOpen="false" v-for="device in devices" :data="device" :label="device.name" :key="device.name[0]">
            <div slot="icon" class="icon">
              <span aria-hidden="true" class="glyphicon glyphicon-phone-alt"/>
            </div>
            <tree :data="device">
            </tree>
          </vuestic-tree-category>
        </vuestic-tree-category>
      </vuestic-tree-root>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import axios from 'axios'
  import store from '../../../store'
  import client from '../../../fractel/clients/CDR/CDR.vue'
  import Tree from './Tree.vue'


  export default {
    name: 'communication-tab',
    components: {
      Tree
    },
    mounted () {
      this.getObjects()
    },
    data: function () {
      return {
        client,
        fonenumbers: [],
        speedDials: [],
        devices: [],
        dummy: {
          children: [
            {}
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ]),
    },
    methods: {
      getObjects: async function () {
        try {
          store.commit('setLoading', true)
          var self = this
          const url = self.client.methods.api_url('/features')
          const options = self.client.methods.api_options()
          axios.get(url, options)
            .then((response) => {
              self.fonenumbers = response.data.fonenumbers
              self.speedDials = response.data.speedDials
              self.devices = response.data.devices
              store.commit('setLoading', false)
            })
            .catch((error) => {
              console.log(error)
              store.commit('setLoading', false)
              if (error.response.status === 401) {
                self.$router.push({ name: 'Logout' })
              }
            })
        } catch (error) {
          console.log(error)
          store.commit('setLoading', false)
          if (error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../../sass/variables";
  .tree {
    max-height: 100px;
    width: 100%;
  }
  .widget-header {
    height: $widget-header-height;
    padding: 0 $widget-padding;
    margin-bottom: $widget-padding;
    border-bottom: $widget-header-border;
    font-size: $font-size-larger;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/communication-tab/Communication.vue